// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"12589":"d8456254","36914":"0ce063d4","42110":"114d8062","69396":"1ecd2a9d","88151":"eec4b341","89103":"f58203c0"}[chunkId] + ".css";
};